<template>
    <div class="breadcrumb-wrapper bg-white p-4">
        <a-breadcrumb>
            <a-breadcrumb-item>
                <router-link to="/">首页</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-for="item in navList" :key="item.path">
                <router-link :to="item.path">{{ item.text }}</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ currentText }}</a-breadcrumb-item>
        </a-breadcrumb>
    </div>
</template>

<script>
import { menu } from "../store/menu"

export default {
    props: {
        currentText: {
            type: String,
            default: "正文"
        },
        list: Array,
        category: null
    },
    computed: {
        navList() {
            if (this.list) {
                return this.list
            }

            if (this.$route.fullPath.includes('/city/')) {
                return [{ path: '/city', text: '城市' }]
            }

            if (this.category && this.category.length > 0) {
                const { id, name, parent } = this.category[0]
                let list = []

                try {
                    if (parent) {
                        // NOTE primary & secondary
                        const primary = menu.list.filter(
                            item => item.id == parent.id
                        )[0]

                        list.push({ path: primary.path, text: primary.name })
                        list.push({
                            path: `${primary.path}?cat=${id}`,
                            text: name
                        })
                    } else {
                        // NOTE primary 
                        const primary = menu.list.filter(
                            item => item.id == id
                        )[0]

                        list.push({ path: primary.path, text: primary.name })
                    }

                    return list
                } catch (err) {}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.breadcrumb-wrapper {
    border-bottom: 1px solid var(--border-color);
}
</style>